import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setAddKidStatus } from "../../AxiosRtk/AddNewChild";
import { useHistory } from "react-router-dom";
import useSubscription from "../../../customHooks/subscriptionProvider";
import {
  timeSupervision as timeSupervisionService,
} from "../../AxiosRtk/DashBoard";
import useFirebase from "../../../../useFirebase";
import { setActiveTab } from "../../AxiosRtk/SetRules";
import { isEmpty } from "lodash";

function timeFormat(timeDuration = 0) {
  if (!timeDuration) {
    return `00 h 00 m 00 s`;
  }

  const hours = Math.floor(timeDuration / 60);
  const minutes = Math.floor(timeDuration % 60);

  return `${hours < 10 ? `0${hours}` : hours} h ${minutes < 10 ? `0${minutes}` : minutes
    } m 00 s`;
}

function timeFormatSec(seconds = 0) {
  if (!seconds) {
    return `00 h 00 m 00 s`;
  }

  var hours = Math.floor(seconds / 3600);
  var minutes = Math.floor((seconds % 3600) / 60);
  var remainingSeconds = seconds % 60;

  return `${hours}h ${minutes}m ${remainingSeconds}s`;
}

const DashboardDailyLimit = ({ getLangTranslation }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { slotData, kidList, selectedKidId, selectedDeviceData } = useSelector(
    ({ dashboard }) => dashboard
  );
  const { setRulesData: setRulesReducerData } = useSelector(
    ({ setRules }) => setRules
  );
  const [timeSuperVisionCheck, setTimeSuperVisionCheck] = useState(false);
  const { checkSubsciption } = useSubscription();
  const { getCollectionData, callFirebase } = useFirebase();
  const isKidListEmpty = kidList?.length === 0 ? true : false;
  function handleAddDevice() {
    if (!checkSubsciption()) {
      return;
    }
    history.push("/connect-child-device");
    dispatch(setAddKidStatus("CONNECT_CHILD_DEVICE"));
  }

  function timeSupervisionApi(timeSupervision) {
    const payload = {
      kidId: selectedKidId,
      deviceId: selectedDeviceData?.ID,
      IsDeviceTimeSupervisionEnabled: timeSupervision,
      dailyLimitSeekBarProgress: 0,
    };

    timeSupervisionService(payload)
      .then(() => { })
      .catch((err) => {
        console.log(
          "time supervision catch error ==>>",
          err?.response?.data?.message
        );
      });
  }

  function handleDeviceTimeSupervisionBtn(e) {
    if (!checkSubsciption()) {
      return;
    }
    const { checked } = e.target;
    setTimeSuperVisionCheck(checked);
    timeSupervisionApi(checked ? 1 : 0);

    const collectionPayload = {
      timesupervison: {
        ...setRulesReducerData?.timesupervison,
        isDeviceTimeSupervisionEnabled: checked ? 1 : 0,
      },
    };

    callFirebase(selectedDeviceData?.ID, collectionPayload);
  }

  useEffect(() => {
    if (setRulesReducerData) {
      setTimeSuperVisionCheck(
        setRulesReducerData?.timesupervison?.isDeviceTimeSupervisionEnabled
      );
    }
  }, [setRulesReducerData]);

  useEffect(() => {
    if (selectedDeviceData) {
      getCollectionData(selectedDeviceData?.ID);
    }
  }, [selectedDeviceData]);

  function getDailyTimeLimit() {
    // Create a new Date object
    var currentDate = new Date();

    // Get the day of the week (0 for Sunday, 1 for Monday, ..., 6 for Saturday)
    var dayNum = currentDate.getDay();

    // Define an array with the names of the days
    var daysOfWeek = [
      "sunday",
      "monday",
      "tuesday",
      "wednesday",
      "thursday",
      "friday",
      "saturday",
    ];

    // Get the name of the day using the day of the week
    var today = daysOfWeek[dayNum];
    if (!isEmpty(setRulesReducerData?.timesupervison?.schedule)) {
      let totalTime = 0;
      const schedule = setRulesReducerData?.timesupervison?.schedule;
      schedule?.forEach((item) => {
        if (item?.day === today) {
          const endTime = item?.endTime ? item?.endTime : '0:0';
          const startTime = item?.startTime ? item?.startTime : '0:0';

          const endTimeMin = parseInt(endTime?.split(":")[0]) * 60 + parseInt(endTime?.split(":")[1]);
          const startTimeMin = parseInt(startTime?.split(":")[0]) * 60 + parseInt(startTime?.split(":")[1]);

          const minDiff = endTimeMin - startTimeMin;
          totalTime = totalTime + minDiff;
        }
      })
      if (totalTime > 0) {
        return timeFormat(totalTime);
      }
    }

    if (!isEmpty(setRulesReducerData?.timesupervison?.dailyLimit)) {
      const dailyLimitObj = setRulesReducerData?.timesupervison?.dailyLimit;
      const totalMin = dailyLimitObj[today];
      if (totalMin > 0) {
        return timeFormat(totalMin);
      }
    }

    // If daily limit is not setted, retuning 24 hrs of time
    return timeFormat(1440);
  }

  function handleSetDailyLimit() {
    if (setRulesReducerData) {
      const timesupervision = setRulesReducerData?.timesupervison;
      if (
        timesupervision?.isDeviceTimeSupervisionEnabled &&
        (timesupervision?.isBlockWebAndAppEnabled ||
          timesupervision?.isWarnKidByAlertEnabled)
      ) {
        history.push("/set-daily-limit");
      } else {
        history.push("/set-rules");
        dispatch(setActiveTab("SETRULE_TIME_SUPERVISION"));
      }
    } else {
      history.push("/set-rules");
    }
  }

  const isDevicesAvailable = kidList && selectedKidId
    ? kidList.find(kid => kid?.ID === selectedKidId)?.KidsDevices?.[0]?.Name
    : null;

  return (
    <>
      <div className="list-item">
        <span
          className={`icon-wrap ${isKidListEmpty ? "icon-gray" : "icon-blue"
            } me-2 pt-cursor`}
          onClick={() => {
            if (!checkSubsciption()) {
              return;
            }
            handleSetDailyLimit();
          }}
        >
          <i
            className={`icon-edit-one fs-5 ${isKidListEmpty ? "text-gray" : ""
              }`}
          />
        </span>
        <div className="list-content">
          <span className="text-small text-uppercase">
            {getLangTranslation(
              "SET_DAILY_TIME_SET_THE_DAILY_TIME_LIMIT",
              "Set the daily time limit"
            )}
          </span>
          {isKidListEmpty ? (
            <p className="mb-0 text-gray">{getDailyTimeLimit()}</p>
          ) : (
            <h5 className="mb-0 text-blue-800">{getDailyTimeLimit()}</h5>
          )}
        </div>
      </div>
      <div className="list-item">
        <div className="list-content">
          <span className="text-small text-uppercase">
            {getLangTranslation("PARENT_DASHBOARD_SCREEN_TIME", "Screen Time")}
          </span>
          {/* {isKidListEmpty ? (
            <p className="mb-0 text-gray">
              {timeFormatSec(slotData?.total_time_used)}
            </p>
          ) : (
            <h5 className="mb-0">{timeFormatSec(slotData?.total_time_used)}</h5>
          )} */}
          {isDevicesAvailable ? (
            isKidListEmpty ? (
              <p className="mb-0 text-gray">{timeFormatSec(slotData?.total_time_used)}</p>
            ) : (
              <h5 className="mb-0 text-blue-800">{timeFormatSec(slotData?.total_time_used)}</h5>
            )
          ) : (
            isKidListEmpty ? (
              <p className="mb-0 text-gray">00h 00m 0s</p>
            ) : (
              <h5 className="mb-0 text-blue-800">00h 00m 0s</h5>
            )
          )}
        </div>
      </div>
      <div className="list-item">
        <div className="form-check form-switch">
          <input
            className="form-check-input"
            type="checkbox"
            role="switch"
            id="deviceTime"
            checked={timeSuperVisionCheck}
            disabled={!selectedDeviceData}
            onChange={handleDeviceTimeSupervisionBtn}
          />
          <label className="form-check-label" htmlFor="deviceTime">
            {getLangTranslation(
              "TIME_SUPERVISION_DEVICE_TIME_SUPERVISION_ENABLE",
              "Device time supervision"
            )}
          </label>
        </div>
      </div>
      {kidList?.length > 0 && (
        <button
          className="btn btn-outline-primary text-uppercase ms-auto d-inline-flex align-items-center gap-1"
          onClick={handleAddDevice}
        >
          <i className="icon-plus fs-5" />
          {getLangTranslation("EDIT_CHILD_ADD_NEW_DEVICE", "Add New Device")}
        </button>
      )}
    </>
  );
};

export default DashboardDailyLimit;
